import { tw } from '~/utils';

export type RewardTypeSelectButtonsStyles = {
  base: string;
  active: string;
};

export const rewardTypeSelectButtonsStyles = tw<RewardTypeSelectButtonsStyles>({
  base: tw(
    'border-grey-300 border-b-brand text-grey-400 mb-[-1px] flex min-h-[100px] flex-col items-center rounded-t-md border bg-white px-2 py-4 transition-colors'
  ),
  active: tw('border-brand text-grey-950 border border-b-1 border-b-white [box-shadow:0_2px_0_0_#fff]'),
});
